import Box from "@mui/material/Box";
import * as React from "react";
import { useCallback, useState } from "react";

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import CertificationRtePhase2Form from "./CertificationRtePhase2Form";
import axios, { AxiosError } from "axios";
import { SubmitHandler } from "react-hook-form";
import { FieldValues } from "react-hook-form";
import { useDataProvider, useNotify } from "react-admin";
import { getRawUrlBase, SiteResourcesEnum } from "shared/enums/resourceMappings";

type RadioValueType = "report" | "csv";

const CertificationRtePhase2 = () => {
  const [formType, setFormType] = useState<RadioValueType>("report");
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setFormType(event.target.value as RadioValueType);
  }, []);

  const prepareData = useCallback(
    async (values: FieldValues) => {
      const { edr_id, site_ids, ...rest } = values;
      const { data: group } = await dataProvider.getOne(SiteResourcesEnum.Groups, { id: edr_id });
      if (!group) {
        notify("Group not found", { type: "error" });
        return;
      }
      return { ...rest, edr_name: group.name, site_ids: site_ids.map((id: number) => `${id}`) };
    },
    [dataProvider, notify],
  );

  const handleSubmit: SubmitHandler<FieldValues> = useCallback(
    async (values) => {
      const data = await prepareData(values);
      if (!data) return;

      try {
        const { status } = await axios({
          method: "post",
          url: `${getRawUrlBase(SiteResourcesEnum.CertificationRtePhase2)}/${formType}`,
          data,
        });
        if (status >= 200 && status < 300) {
          notify(`Succefully started ${formType} generation`, { type: "success" });
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        const errorData = axiosError.response?.data;
        if (errorData && Array.isArray(errorData)) {
          const message = `${errorData[0]?.error_code} : ${errorData[0]?.message}`;
          notify(message, { type: "error" });
        } else {
          notify(`There was a problem starting ${formType} generation`, { type: "error" });
        }
      }
    },
    [notify, formType, prepareData],
  );

  return (
    <Box sx={{ width: "100%" }}>
      <FormControl sx={{ mx: 2 }}>
        <FormLabel>Type</FormLabel>
        <RadioGroup row name="type" value={formType} onChange={handleChange}>
          <FormControlLabel value="report" control={<Radio />} label="Report Generation" />
          <FormControlLabel value="csv" control={<Radio />} label="CSV Generation" />
        </RadioGroup>
      </FormControl>

      <CertificationRtePhase2Form handleSubmit={handleSubmit} />
    </Box>
  );
};

export default CertificationRtePhase2;
